import { Component, OnInit } from '@angular/core';
import { DashboardInfo, Transaction, Option } from './models';
import { PopupSignalService } from '../../services/popup-signal.service';
import { HttpService } from '../../http.service';
import { FileDownloadService } from '../../services/file-download.service';

@Component({
  templateUrl: 'home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  dashboardInfo?: DashboardInfo;
  dataSource: any;
  transactions: Transaction[] = [];

  datasourceReportType: Option[] = [
    { text: 'Excell', value: 0 },
    { text: 'PDF', value: 1 }
  ];
  reportType: number = this.datasourceReportType[0].value; // Default value

  constructor(private popupSignalService: PopupSignalService, private httpService: HttpService, private fileDownloadService: FileDownloadService) {
  }

  ngOnInit() {

    this.httpService.getTransactionsByMerchant().subscribe(res => {
      this.transactions = res;
    });

    this.httpService.getDashboardInfo().subscribe(res => {
      this.dashboardInfo = res;
    });
  }

  showPopup = (e) => {
    this.popupSignalService.showPopup();
  };

  transactionReport = (e) => {
    this.httpService.getTransactionReport(this.reportType).subscribe(res => {
      window.open(res);
    });
  };
}
